export default {
  path: '/products',
  name: 'products',
  component: () => import(/* webpackChunkName: "list-view-products" */ './ListViewProducts'),
  meta: {
    requiresAuth: true
  }
}
